import { HttpReturnProcessOrderList, HttpExportReturnProcessOrder } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
            formData: {},
        };
    },
    methods: {
        ajaxRequest: HttpReturnProcessOrderList,
        handleOperates(params, type) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportReturnProcessOrder, this.formData, { executor: 'request', download: true });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeids: params,
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "salesHandleOrderDetail",
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                show: this.handleAuth('fbb.returnplan.export'),
                operate: "export",
            }]
        },
        SearchsData() {
            let widthStyle = 'width: 218px;'
            return [
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    },
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "退货处理单号" }),
                    key: 'EQ_returnProcessOrderNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:20px',
                },
                {
                    label: this.$t('', { defaultValue: "退货处理计划单号" }),
                    key: 'EQ_returnProcessPlanOrderNo',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('', { defaultValue: "状态" }),
                    key: 'EQ_status',
                    tag: 'Select',
                    options: this.getSalesHandleOrderStatus.slice(1),
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'Select',
                    options: this.getUserManageWarehouseList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    width: 100,
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)||'--'
                },
                {
                    title: this.$t('', { defaultValue: "退货处理单号" }),
                    key: 'returnProcessOrderNo',
                    render: (h, { row }) => {
                        return <div>
                                <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.returnProcessOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "来源单号" }),
                    key: 'sourceNo',
                    render: (h, { row }) => {
                        return <div>{ row.sourceNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "退货处理计划单号" }),
                    key: 'returnProcessPlanOrderNo',
                    render: (h, { row }) => {
                        return <div>{ row.returnProcessPlanOrderNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '状态' }),
                    key: "status",
                    render: (h, { row }) => {
                        const status = row.status
                        const { label = '', theme} = this.getSalesHandleOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return  <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render:( h, { row })=>{
                        const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code === row.orgWarehouseCode)
                        return <div>{ wareHouse[0] ? wareHouse[0].label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)|| '--'
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




